var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 3V2C2.44772 2 2 2.44772 2 3H3ZM10 3H11C11 2.44772 10.5523 2 10 2V3ZM10 10V11C10.5523 11 11 10.5523 11 10H10ZM3 10H2C2 10.5523 2.44772 11 3 11V10ZM14 3V2C13.4477 2 13 2.44772 13 3H14ZM21 3H22C22 2.44772 21.5523 2 21 2V3ZM21 10V11C21.5523 11 22 10.5523 22 10H21ZM14 10H13C13 10.5523 13.4477 11 14 11V10ZM14 14V13C13.4477 13 13 13.4477 13 14H14ZM21 14H22C22 13.4477 21.5523 13 21 13V14ZM21 21V22C21.5523 22 22 21.5523 22 21H21ZM14 21H13C13 21.5523 13.4477 22 14 22V21ZM3 14V13C2.44772 13 2 13.4477 2 14H3ZM10 14H11C11 13.4477 10.5523 13 10 13V14ZM10 21V22C10.5523 22 11 21.5523 11 21H10ZM3 21H2C2 21.5523 2.44772 22 3 22V21ZM3 4H10V2H3V4ZM9 3V10H11V3H9ZM10 9H3V11H10V9ZM4 10V3H2V10H4ZM14 4H21V2H14V4ZM20 3V10H22V3H20ZM21 9H14V11H21V9ZM15 10V3H13V10H15ZM14 15H21V13H14V15ZM20 14V21H22V14H20ZM21 20H14V22H21V20ZM15 21V14H13V21H15ZM3 15H10V13H3V15ZM9 14V21H11V14H9ZM10 20H3V22H10V20ZM4 21V14H2V21H4Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.2d8c73cb4fefb8b8a1a97a09005fcf87.svg";
export { ForwardRef as ReactComponent };